import { ChangeEvent, Component } from "react";
import {
    createStyles,
    Paper,
    Theme,
    WithStyles,
    withStyles
} from "@material-ui/core";
import { Cancel, Save, VpnKey } from "@material-ui/icons";
import $ from "jquery";
import { enqueueSnackbar } from "notistack";
import * as postcode from "postcode-validator";
import { connect } from "react-redux";
import { Redirect, RouteComponentProps } from "react-router";
import { bindActionCreators } from "redux";
import { ISetPassword } from "../../../models/account/IResetPassword";
import IUserProfile from "../../../models/account/IUserProfile";
import Constants from "../../../models/utility/Constants";
import { LoadState } from "../../../models/utility/LoadState";
import FullscreenLoader from "../../layout/FullscreenLoader";
import FormErrorWrapper from "../../shared/FormErrorWrapper";
import LoaderButton from "../../shared/LoaderButton";
import AccountDetails from "../../shared/registration/AccountDetails";
import ProfileInformation from "../../shared/registration/ProfileInformation";
import SectionBanner from "../../shared/SectionBanner";
import { IAppDispatch, IAppState } from "./../../../store";
import * as UserStore from "./../../../store/UserStore";

type ManageUserDetailsProps = UserStore.IUserStoreState &
    typeof UserStore.actionCreators &
    WithStyles<typeof styles> &
    RouteComponentProps<{ id: string }>;

interface IManageUserDetailsState {
    address1: string;
    address2: string;
    city: string;
    confirmPassword: string;
    country: string;
    email: string;
    errorMessages: string[];
    firstName: string;
    isAdmin: boolean;
    isCreate: boolean;
    hasErrors: boolean;
    lastName: string;
    notFound: boolean;
    password: string;
    phoneNumber: string;
    province: string;
    postalCode: string;
    redirect: boolean;
    resetPassword: boolean;
}

const styles = (theme: Theme) =>
    createStyles({
        button: { marginTop: theme.spacing(5) },
        deleteButton: {
            "&:hover": { backgroundColor: theme.palette.error.dark },
            backgroundColor: theme.palette.error.main,
            color: theme.palette.error.contrastText,
            marginRight: theme.spacing(2)
        },
        errorMessage: { textAlign: "left" },
        form: {
            maxWidth: 1000,
            padding: theme.spacing(8),
            width: "100%"
        },
        imageDelete: {
            padding: theme.spacing(),
            position: "absolute",
            right: 0,
            top: 0
        },
        imageDeleteBtn: {
            "&:hover": { color: theme.palette.error.main },
            color: theme.palette.common.white,
            padding: 0
        },
        imageDeleteIcon: {
            filter: "drop-shadow(2px 2px 2px black)",
            msFilter: "drop-shadow(2px 2px 2px black)",
            webkitFilter: "drop-shadow(2px 2px 2px black)"
        },
        paper: {
            alignItems: "center",
            display: "flex",
            flexDirection: "column"
        },
        secondButton: { marginRight: theme.spacing(2) }
    });

class ManageUserDetails extends Component<
    ManageUserDetailsProps,
    IManageUserDetailsState
> {
    constructor(props: ManageUserDetailsProps) {
        super(props);

        Constants.SetDocumentTitle("Account Details");
        const isCreate = this.props.match.params.id === Constants.UrlCreateUser;

        this.state = {
            address1: "",
            address2: "",
            city: "",
            confirmPassword: "",
            country: "CA",
            email: "",
            errorMessages: [],
            firstName: "",
            hasErrors: false,
            isAdmin: false,
            isCreate,
            lastName: "",
            notFound: false,
            password: "",
            phoneNumber: "",
            postalCode: "",
            province: "",
            redirect: false,
            resetPassword: false
        };
    }

    public componentWillMount() {
        $("body, html").animate(
            { scrollTop: 0 },
            Constants.ScrollAnimationLength
        );
        if (this.props.match.params.id !== Constants.UrlCreateUser) {
            this.props.getUserProfile(this.props.match.params.id);
        } else {
            this.props.toggleResetCreateUser();
            this.props.toggleResetDeleteUser();
        }
    }

    public componentDidUpdate(
        prevProps: ManageUserDetailsProps,
        prevState: IManageUserDetailsState
    ) {
        if (
            !this.state.isCreate &&
            prevProps.userProfileLoadState !== LoadState.Loaded &&
            this.props.userProfileLoadState === LoadState.Loaded &&
            !this.props.userProfile
        ) {
            enqueueSnackbar("Couldn't load that user", {
                anchorOrigin: { horizontal: "left", vertical: "top" },
                variant: "error"
            });
            this.setState({ notFound: true });
        }
        if (!prevProps.userProfile && this.props.userProfile) {
            const userProfile = this.props.userProfile;
            this.setState({
                address1: userProfile.address1,
                address2: userProfile.address2,
                city: userProfile.city,
                confirmPassword: "",
                country: userProfile.country,
                email: userProfile.email,
                errorMessages: [],
                firstName: userProfile.firstName,
                hasErrors: false,
                isAdmin: userProfile.isAdmin,
                lastName: userProfile.lastName,
                password: "",
                phoneNumber: userProfile.phoneNumber,
                postalCode: userProfile.postalCode,
                province: userProfile.province
            });
        }
        if (
            (this.props.createUserFailErrors &&
                this.props.createUserFailErrors.length > 0 &&
                prevProps.createUserFailErrors !==
                    this.props.createUserFailErrors) ||
            (this.props.setPasswordFailErrors &&
                this.props.setPasswordFailErrors.length > 0 &&
                prevProps.setPasswordFailErrors !==
                    this.props.setPasswordFailErrors) ||
            (this.state.errorMessages &&
                this.state.errorMessages.length > 0 &&
                prevState.errorMessages !== this.state.errorMessages)
        ) {
            // scroll to top if there are new error messages
            $("body, html").animate(
                { scrollTop: 0 },
                Constants.ScrollAnimationLength
            );
        }
    }

    public render() {
        if (
            !this.state.isCreate &&
            this.props.userProfileLoadState !== LoadState.Loaded
        ) {
            return <FullscreenLoader />;
        }

        if (this.state.notFound) {
            return <Redirect to={Constants.Routes.AdminUserList()} />;
        }

        if (
            this.props.createUserSucceed ||
            this.props.deleteUserSucceed ||
            this.props.setPasswordSucceed ||
            this.state.redirect
        ) {
            if (
                this.props.prevLocation &&
                this.props.prevLocation !==
                    Constants.Routes.AdminUserDetail(this.props.match.params.id)
            ) {
                return <Redirect to={this.props.prevLocation} />;
            } else {
                return <Redirect to={Constants.Routes.AdminUserList()} />;
            }
        }

        const classes = this.props.classes;
        const hasErrors =
            this.state.hasErrors ||
            this.props.createUserFailure ||
            this.props.setPasswordFailure;
        const errorMessages = this.state.errorMessages
            .concat(this.props.createUserFailErrors)
            .concat(this.props.setPasswordFailErrors);

        return (
            <Paper className={classes.paper} elevation={2}>
                <SectionBanner leftSideText="Account Details" />

                <div className={classes.form}>
                    <form>
                        {hasErrors ? (
                            <FormErrorWrapper
                                errors={errorMessages}
                                errorMessage="The following errors occurred during save:"
                            />
                        ) : null}
                        <AccountDetails
                            firstName={this.state.firstName}
                            lastName={this.state.lastName}
                            email={this.state.email}
                            isEdit={!this.state.isCreate}
                            isViewMode={!this.state.isCreate}
                            allowPasswordReset={this.state.resetPassword}
                            onChange={this.onChange}
                        />
                        <ProfileInformation
                            phoneNumber={this.state.phoneNumber}
                            address1={this.state.address1}
                            address2={this.state.address2}
                            country={this.state.country}
                            province={this.state.province}
                            city={this.state.city}
                            postalCode={this.state.postalCode}
                            isViewMode={!this.state.isCreate}
                            onChange={this.onChange}
                        />
                        <div className={classes.button}>
                            {this.state.isCreate && (
                                <LoaderButton
                                    className={classes.secondButton}
                                    loading={
                                        this.props.createUserState ===
                                        LoadState.Loading
                                    }
                                    type="button"
                                    size="large"
                                    variant="contained"
                                    color="primary"
                                    onClick={this.onSubmit}
                                >
                                    <Save />
                                    &nbsp; Create
                                </LoaderButton>
                            )}
                            {!this.state.isCreate &&
                                !this.state.resetPassword && (
                                    <LoaderButton
                                        className={classes.secondButton}
                                        loading={this.state.redirect}
                                        type="button"
                                        size="large"
                                        variant="contained"
                                        color="primary"
                                        onClick={this.allowResetPassword}
                                    >
                                        <VpnKey />
                                        &nbsp; Set Password
                                    </LoaderButton>
                                )}
                            {!this.state.isCreate &&
                                this.state.resetPassword && (
                                    <LoaderButton
                                        className={classes.secondButton}
                                        loading={
                                            this.props.setPasswordLoadState ===
                                                LoadState.Loading ||
                                            this.props.deleteUserState ===
                                                LoadState.Loading
                                        }
                                        type="button"
                                        size="large"
                                        variant="contained"
                                        color="primary"
                                        onClick={this.onSetPassword}
                                    >
                                        <Save />
                                        &nbsp; Update
                                    </LoaderButton>
                                )}
                            <LoaderButton
                                loading={this.state.redirect}
                                type="button"
                                size="large"
                                variant="contained"
                                color="secondary"
                                onClick={this.onClose}
                            >
                                <Cancel />
                                &nbsp; Close
                            </LoaderButton>
                        </div>
                    </form>
                </div>
            </Paper>
        );
    }

    private allowResetPassword = () => {
        this.setState({ resetPassword: true });
        $("body, html").animate(
            { scrollTop: 0 },
            Constants.ScrollAnimationLength
        );
    };

    private onChange = (event: ChangeEvent<HTMLInputElement>) => {
        const name = event.target.name;
        const value = event.target.value as string;

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.setState({ [name]: value } as any);

        // Reset province on country change
        if (name === "country") {
            this.setState({ province: "" });
        }
    };

    private isASCII = (str: string) => {
        // eslint-disable-next-line no-control-regex
        return /^[\x00-\x7F]*$/.test(str);
    };

    private validateForm = () => {
        const errorMessages: string[] = [];
        const requiredMessage = " field is required.";
        if (this.state.firstName.trim().length === 0) {
            errorMessages.push("First Name" + requiredMessage);
        } else if (!this.isASCII(this.state.firstName.trim())) {
            errorMessages.push("First Name contains invalid character(s).");
        }
        if (this.state.lastName.trim().length === 0) {
            errorMessages.push("Last Name" + requiredMessage);
        } else if (!this.isASCII(this.state.lastName.trim())) {
            errorMessages.push("Last Name contains invalid character(s).");
        }
        if (this.state.email.trim().length === 0) {
            errorMessages.push("Email" + requiredMessage);
        } else if (!this.state.email.trim().match(Constants.EmailRegExp)) {
            errorMessages.push("Invalid Email Address");
        } else if (!this.isASCII(this.state.email.trim())) {
            errorMessages.push("Email Address contains invalid character(s).");
        }
        if (this.state.password.trim().length === 0) {
            errorMessages.push("Password" + requiredMessage);
        } else if (this.state.confirmPassword.trim().length === 0) {
            errorMessages.push("Confirm Password" + requiredMessage);
        } else if (this.state.password !== this.state.confirmPassword) {
            errorMessages.push("Provided passwords do not match.");
        } else if (!this.isASCII(this.state.password.trim())) {
            errorMessages.push("Password contains invalid character(s).");
        }
        if (this.state.phoneNumber.trim().length === 0) {
            errorMessages.push("Phone Number" + requiredMessage);
        }
        if (this.state.address1.trim().length === 0) {
            errorMessages.push("Address" + requiredMessage);
        } else if (
            !this.isASCII(this.state.address1.trim()) ||
            !this.isASCII(this.state.address2.trim())
        ) {
            errorMessages.push("Address contains invalid character(s).");
        }
        if (this.state.country.trim().length === 0) {
            errorMessages.push("Country" + requiredMessage);
        }
        if (this.state.province.trim().length === 0) {
            errorMessages.push("Province/State" + requiredMessage);
        }
        if (this.state.city.trim().length === 0) {
            errorMessages.push("Town/City" + requiredMessage);
        } else if (!this.isASCII(this.state.city.trim())) {
            errorMessages.push("Town/City contains invalid character(s).");
        }
        if (this.state.postalCode.trim().length === 0) {
            errorMessages.push("Postal Code/Zip" + requiredMessage);
        } else if (this.state.country === "CA" || this.state.country === "US") {
            if (
                !postcode.postcodeValidator(
                    this.state.postalCode,
                    this.state.country
                )
            ) {
                errorMessages.push("Postal Code/Zip is not valid.");
            }
        }
        const hasErrors = errorMessages.length > 0;
        this.setState({ hasErrors, errorMessages });

        return !hasErrors;
    };

    private onSubmit = () => {
        this.setState({ hasErrors: false, errorMessages: [] });

        if (this.validateForm()) {
            const model = {
                address1: this.state.address1,
                address2: this.state.address2,
                city: this.state.city,
                confirmPassword: this.state.confirmPassword,
                country: this.state.country,
                email: this.state.email,
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                password: this.state.password,
                phoneNumber: this.state.phoneNumber,
                postalCode: this.state.postalCode,
                province: this.state.province
            } as IUserProfile;

            this.setState({ hasErrors: false, errorMessages: [] });
            this.props.createUser(model);
        }
    };

    private validateSetPasswordForm = () => {
        const errorMessages: string[] = [];
        const requiredMessage = " field is required.";
        if (this.state.email.trim().length === 0) {
            errorMessages.push("Email" + requiredMessage);
        } else if (!this.state.email.trim().match(Constants.EmailRegExp)) {
            errorMessages.push("Invalid Email Address");
        }
        if (this.state.password.trim().length === 0) {
            errorMessages.push("Password" + requiredMessage);
        } else if (this.state.confirmPassword.trim().length === 0) {
            errorMessages.push("Confirm Password" + requiredMessage);
        } else if (this.state.password !== this.state.confirmPassword) {
            errorMessages.push("Provided passwords do not match.");
        }
        const hasErrors = errorMessages.length > 0;
        this.setState({ hasErrors, errorMessages });

        return !hasErrors;
    };

    private onSetPassword = () => {
        this.setState({ hasErrors: false, errorMessages: [] });

        if (this.validateSetPasswordForm()) {
            const model = {
                ConfirmPassword: this.state.confirmPassword,
                Email: this.state.email,
                Password: this.state.password
            } as ISetPassword;

            this.setState({ hasErrors: false, errorMessages: [] });
            this.props.setPassword(model);
        }
    };

    private onClose = () => this.setState({ redirect: true });
}

const reduxState = (state: IAppState) => state.userStoreState;
const reduxDispatch = (dispatch: IAppDispatch) =>
    bindActionCreators(UserStore.actionCreators, dispatch);

export default withStyles(styles)(
    connect(reduxState, reduxDispatch)(ManageUserDetails)
);
